'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useMediaQuery = require('./useMediaQuery');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_useMediaQuery).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }